export const links = [
  { name: 'Resume', href: 'https://sumayyah.dev/SumayyahAsgarResume.pdf' },
  { name: 'GitHub', href: 'https://github.com/sumi419' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/in/sumayyahasgar/' },
  { name: 'Twitter', href: 'https://twitter.com/sumayyahasgar' },
  { name: 'Email', href: 'mailto:sasgar04@gmail.com' }
];
